import React from 'react';
import { FeatureIntroductionBanner } from '@components/notifications/banner/Banners';
import { Link, Text } from '@amzn/storm-ui';
import {
  REGISTRATION_GENERAL_INFO_BANNER_TITLE_TRANSLATION_KEY,
  REGISTRATION_GENERAL_INFO_BANNER_MESSAGE_TRANSLATION_KEY,
} from '@features/account-registration/constants';
import useIntl from '@i18n/useIntl';
import { DynamicText } from 'src/shared/components/DynamicText';
import { REGISTRATION_INFO_MESSAGE_LEARN_MORE_URL } from 'src/pages/registration/constants';
import { useSelector } from 'react-redux';
import { RootState } from 'src/shared/state/store';

interface RegistrationGeneralInfoBannerProps {
  id: string;
}

const RegistrationGeneralInfoBanner = ({
  id,
}: RegistrationGeneralInfoBannerProps) => {
  const { intl } = useIntl();
  const linkConfig = {
    learnMoreLink: REGISTRATION_INFO_MESSAGE_LEARN_MORE_URL,
  };
  const alerts = useSelector((state: RootState) => state.alert.alerts);

  // If we have alerts, we do not want to display this component; we should let the alert banner be displayed instead.
  if (alerts.length > 0) {
    return null;
  }
  return (
    <FeatureIntroductionBanner id={id} duration={0}>
      <>
        <Text type="h4">
          {intl.getMessage(
            REGISTRATION_GENERAL_INFO_BANNER_TITLE_TRANSLATION_KEY,
          )}
        </Text>
        <DynamicText
          message={intl.getMessage(
            REGISTRATION_GENERAL_INFO_BANNER_MESSAGE_TRANSLATION_KEY,
          )}
          resolveComponent={(part) => (
            <Link href={linkConfig[part as keyof typeof linkConfig]}>
              <Text type="h4" color="primary"></Text>
              {/* TODO: Currently, REGISTRATION_INFO_MESSAGE_LEARN_MORE_URL points to an empty URL. This is
               *       because the page is new for SGA M2 and, at time of commit, is not ready yet. When it
               *       is ready, the URL will be updated to the correct page and we should update the below
               *       line from an empty string to the commented-out string translation logic.
               */}
              {
                '' /* intl.getMessage(REGISTRATION_GENERAL_INFO_BANNER_MESSAGE_LINK_TEXT_TRANSLATION_KEY) */
              }
            </Link>
          )}
        />
      </>
    </FeatureIntroductionBanner>
  );
};

export default RegistrationGeneralInfoBanner;
